import { useParams } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { useMap } from "react-leaflet";

import { useGetTrackingReferences } from "api/queries/shipments/useGetTrackingReferences";
import TruckMarkerBlue from "assets/images/mapMarkers/TruckMarkerBlue.svg";
import TruckMarkerPurple from "assets/images/mapMarkers/TruckMarkerPurple.svg";
import TruckMarkerOrange from "assets/images/mapMarkers/TruckMarkerOrange.svg";
import TruckMarkerPink from "assets/images/mapMarkers/TruckMarkerPink.svg";
import TruckMarkerItem from "./TruckMarkerItem";

const truckMarkers = [TruckMarkerBlue, TruckMarkerPurple, TruckMarkerOrange, TruckMarkerPink];
const truckLinesColors = ["#0071CE", "#7A5AF8", "#FF8838", "#EE46BC"];

export default function TruckMarkers() {
  const { id } = useParams();
  const map = useMap();

  const { data: trackingReferencesData } = useGetTrackingReferences(id!, {
    enabled: !!id,
    refetchOnMount: false,
  });

  const firstFourTruckReferences = useMemo(
    () =>
      trackingReferencesData?.references
        ?.filter((ref: any) => ref.type === "truck" && ref.truck_tracking_info?.locations?.length)
        ?.slice(0, 4) || [],
    [trackingReferencesData],
  );

  const coordinates: Array<[]> = useMemo(
    () =>
      firstFourTruckReferences.map((ref: any) =>
        ref.truck_tracking_info.locations
          .map((item: any) => [item.latitude, item.longitude])
          .slice()
          .reverse(),
      ),
    [firstFourTruckReferences],
  );

  useEffect(() => {
    if (!coordinates?.length) {
      return;
    }
    const longestSubarray = coordinates.reduce(
      (maxArr, currArr) => (currArr.length > maxArr.length ? currArr : maxArr),
      coordinates[0],
    );
    if (longestSubarray?.length) {
      setTimeout(() => {
        map.setView([longestSubarray!.at(-1)![0], longestSubarray!.at(-1)![1]], 15);
      }, 500);
    }
  }, [coordinates]);

  return (
    <div>
      {coordinates.map((coords, index) => (
        <TruckMarkerItem key={index} coords={coords} marker={truckMarkers[index]} lineColor={truckLinesColors[index]} />
      ))}
    </div>
  );
}
